import _ from "lodash";

export function getChildDataFromObject(object, path, defaultValue?) {
    defaultValue = defaultValue || "";
    var data = _.get(object, path, defaultValue);

    if (!data && data !== 0 && data !== false) {
        data = defaultValue;
    }

    return data;
}
